// Status colors shared by the review list and detail.
export const moderationColor = (status?: string | null) =>
  status === "approved" ? "teal" : status === "rejected" ? "red" : status === "pending" ? "yellow" : "gray";
export const visibilityColor = (status?: string | null) =>
  status === "published" ? "green" : "gray";
